export default __webpack_public_path__ + "static/media/ring.99969b37.wav";